import request from '../request';

export interface IChangePasswordRequest {
  username: string;
  appCode: string;
  oldPassword: string;
  newPassword: string;
}

export interface IChangePasswordResponse {
  code: string;
  message?: string;
  timestamp?: string;
  data: {
    username: string;
  };
}

export const changePassword = async (data: IChangePasswordRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/user/change-password`;
  const res = await request<IChangePasswordResponse>('post', url, data);
  return res;
};
